/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const legalRegulatoryEnumsIssueResultFromANonComplianceEventOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    NotSure: 'NotSure',
} as const;

export type LegalRegulatoryEnumsIssueResultFromANonComplianceEventOptionEnumKey =
    (typeof legalRegulatoryEnumsIssueResultFromANonComplianceEventOptionEnum)[keyof typeof legalRegulatoryEnumsIssueResultFromANonComplianceEventOptionEnum];

export type LegalRegulatoryEnumsIssueResultFromANonComplianceEventOption =
    LegalRegulatoryEnumsIssueResultFromANonComplianceEventOptionEnumKey;
